import React, {useRef, useState} from 'react';
// Import Swiper React components
import {Swiper, SwiperSlide} from 'swiper/react';
import {Container, Col, Row, Image} from 'react-bootstrap'
import CustomButton from "../accesories/customBtn/CustomButton";
import {FaPhone} from "react-icons/fa";
import {TiPhoneOutline} from "react-icons/ti";
import {AiOutlinePhone} from "react-icons/ai";
import {AiOutlineEnter} from "react-icons/ai";
import {HiOutlineChatBubbleBottomCenterText} from "react-icons/hi2";


// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

import './sample.css';

// import required modules
import {Pagination, Autoplay} from 'swiper/modules';


function Sample(props) {

    ///added to handle auto play
    const swiperRef = useRef(null);

    const handleMouseEnter = () => {
        if (swiperRef.current) {
            swiperRef.current.autoplay.stop();
        }
    };

    const handleMouseLeave = () => {
        if (swiperRef.current) {
            swiperRef.current.autoplay.start();
        }
    };
    /////////////


    return (

        <div className={'change-slider-wrapper'}>
            <Swiper
                spaceBetween={30}
                pagination={{
                    el: ".custom-pagination",
                    clickable: true,
                }}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false
                }}
                loop={true}
                speed={1000}
                modules={[Autoplay, Pagination]}
                className="mySwiper"
                onSwiper={(swiper) => {
                    swiperRef.current = swiper;
                }}
            >
                <SwiperSlide>
                    <Container>
                        <Row>
                            <Col sm={12} md={6}
                                 // added to handle auto play
                                 onMouseEnter={handleMouseEnter}
                                 onMouseLeave={handleMouseLeave}
                                 className={'right-col d-flex justify-content-center align-items-start flex-column'}>
                                <h2>گروه نرم افزاری داپا
                                </h2>
                                <p className={'text-end'}>برای موفقیت در کسب و کارت کافیه با ما همراه بشی ما در تمام
                                    لحظات کنارتیم تا همیشه
                                    بهترین باشی
                                </p>
                                <div className={'d-flex gap-3'}>
                                    <CustomButton icon={<i className="fa-regular fa-phone-flip"></i>}
                                                  bgColor={'#D3EDE6'} height={'4.5rem'}
                                                  width={'12.5rem'} href={'www.dapa.com'} text={'راهنمایی نیاز داری؟'}/>
                                    <CustomButton icon={<i className="fa-solid fa-arrow-turn-down-left"></i>}
                                                  bgColor={'#1D2E3D'}
                                                  color={'#fff'} width={'12.5rem'} height={'4.5rem'}
                                                  href={'www.dapa.com'} text={'با ما آشنا شو'}/>

                                </div>
                            </Col>
                            <Col sm={12} md={6} className={'d-flex align-items-center justify-content-center'}>

                                <Image src="images/02.png" alt=""/>
                            </Col>
                        </Row>
                    </Container>
                </SwiperSlide>

                <SwiperSlide>
                    <Container>
                        <Row>
                            <Col sm={12} md={6}
                                // added to handle auto play
                                 onMouseEnter={handleMouseEnter}
                                 onMouseLeave={handleMouseLeave}
                                 className={'right-col d-flex justify-content-center align-items-start flex-column'}>
                                <h2>گروه نرم افزاری داپا
                                </h2>
                                <p className={'text-end'}>برای موفقیت در کسب و کارت کافیه با ما همراه بشی ما در تمام
                                    لحظات کنارتیم تا همیشه
                                    بهترین باشی
                                </p>
                                <div className={'d-flex gap-3'}>
                                    <CustomButton icon={<i className="fa-regular fa-phone-flip"></i>}
                                                  bgColor={'#D3EDE6'} height={'4.5rem'}
                                                  width={'12.5rem'} href={'www.dapa.com'} text={'راهنمایی نیاز داری؟'}/>
                                    <CustomButton icon={<i className="fa-solid fa-arrow-turn-down-left"></i>}
                                                  bgColor={'#1D2E3D'}
                                                  color={'#fff'} width={'12.5rem'} height={'4.5rem'}
                                                  href={'www.dapa.com'} text={'با ما آشنا شو'}/>

                                </div>
                            </Col>
                            <Col sm={12} md={6} className={'d-flex align-items-center justify-content-center'}>

                                <Image src="images/02.png" alt=""/>
                            </Col>
                        </Row>
                    </Container>
                </SwiperSlide>

                {/*<SwiperSlide>Slide 3</SwiperSlide>*/}
                {/*<SwiperSlide>Slide 4</SwiperSlide>*/}
                {/*<SwiperSlide>Slide 5</SwiperSlide>*/}
                {/*<SwiperSlide>Slide 6</SwiperSlide>*/}
                {/*<SwiperSlide>Slide 7</SwiperSlide>*/}
                {/*<SwiperSlide>Slide 8</SwiperSlide>*/}
                {/*<SwiperSlide>Slide 9</SwiperSlide>*/}
            </Swiper>
            <div className="custom-pagination"></div>
        </div>
    );
}

export default Sample;